import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { WorkstationCategoryDTO } from '../../workstation-category/dto/workstation-category.dto';
export class OperationDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Operation id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  operationId: number;

  @ApiProperty()
  @MaxLength(30, { message: "Operation Code allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Operation Code should be only alpha numeric" })
  operationCode: string;

  @ApiProperty()
  @MaxLength(30, { message: "Operation Name allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Operation Name should be only alpha numeric" })
  operationName: string;

  @ApiProperty()
  @MaxLength(30, { message: "currency allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"currency should be only alpha numeric" })
  workstationCategoryId: number;

  
  @ApiProperty()
  isValueAddition: boolean;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty({ type: [WorkstationCategoryDTO]})
  workstationCategoryInfo: WorkstationCategoryDTO;

  @ApiProperty()
  @IsOptional()
  workstationCategoryName: string;

  @ApiProperty()
  @IsOptional()
  isUpdate: boolean;

}

